module.exports = __webpack_public_path__ + "static/media/5.9fab9587.png";